import { Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import SignaturePad from 'signature_pad';
import { AppService } from 'src/app/services/app/app.service';
import { CommonService } from 'src/app/services/common/common.service';
import { JobAcceptService } from 'src/app/services/job-accept/job-accept.service';

@Component({
  selector: 'app-manager-sign',
  templateUrl: './manager-sign.component.html',
  styleUrls: ['./manager-sign.component.scss']
})
export class ManagerSignComponent {
  public signPad: any;
  @ViewChild("signPadCanvas", { static: false }) signaturePadElement: any;
  @ViewChild("signbox", { static: false }) signBox: any;
  constructor(private dialogRef:MatDialogRef<ManagerSignComponent>,private appService:AppService,private commonService:CommonService,
    private jobAcceptService:JobAcceptService,@Inject(MAT_DIALOG_DATA) public dialogaData:any,) { }
  
  ngOnInit(): void {
  }
  ngAfterViewInit() {
    this.signPad = new SignaturePad(this.signaturePadElement.nativeElement);
    this.resizeCanvas()
  }
  resizeCanvas() {
    const canvas = this.signaturePadElement.nativeElement;
    const context = canvas.getContext('2d');

    // Set canvas width and height dynamically
    const dynamicWidth = this.signBox.nativeElement.offsetWidth - 16
    const dynamicHeight = this.signBox.nativeElement.offsetHeight - 16
    canvas.width = dynamicWidth;
    canvas.height = dynamicHeight;
  }
  clearSignPad() {
    this.signPad.clear();
  }
  onEndStroke(event: Event) {
  }
  /*Here you can save the signature as a Image*/
  saveSignPad() {
    const base64ImageData = this.signPad.toDataURL();
    //Here you can save your signature image using your API call.
   
    const formData=new FormData()
    formData.append('sign',base64ImageData)
    formData.append('j_id',this.dialogaData.j_id);
    formData.append('woti_id',this.dialogaData.woti_id);

    const data={};
    this.jobAcceptService.managerSign(formData).subscribe({
      next: (success: any) => {
          if (success.status == 200) {
            this.appService.showToastMessage('success',success.msg)
            this.dialogRef.close({sign:base64ImageData})
          }
      },
      error: (error: any) => {
          this.commonService.handleError(error)
      }
  })
  }
}
